module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.values), function(val, idx) {
    return _c('v-radiobutton', {
      key: _vm.id + '_' + idx,
      attrs: {
        "id": _vm.id + '_' + idx,
        "label": _vm.labels[idx],
        "val": val,
        "name": _vm.name,
        "value": _vm.value
      },
      on: {
        "input": _vm.onInput
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0973e163","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/form/RadioButtonGroup.vue
// module id = 502
// module chunks = 1